import { render, staticRenderFns } from "./SubmitAuthor.vue?vue&type=template&id=dfa96eb0&scoped=true"
import script from "./SubmitAuthor.vue?vue&type=script&lang=js"
export * from "./SubmitAuthor.vue?vue&type=script&lang=js"
import style0 from "./SubmitAuthor.vue?vue&type=style&index=0&id=dfa96eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa96eb0",
  null
  
)

export default component.exports